import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="textbaustein"
export default class extends Controller {
  static targets = ["textbausteinContainer", "editor"]
  connect() {
  }

  textbausteinContainerTargetConnected() {
    if (!this.textbausteinContainerTarget.innerHTML.trim()) return // Abbrechen, wenn Container leer ist
		this.insertTextbausteinIntoTextarea()
	}

  insertTextbausteinIntoTextarea() {
    this.content = this.textbausteinContainerTarget.innerText
    this.editorTarget.editor.insertHTML(this.content)
    this.editorTarget.dispatchEvent(new Event("keyup")) // Keyup simulieren, damit Autosave-Methode der Textarea getriggert wird
  }
}
